function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.106 0h12.739c.072 0 .134.047.15.116a.143.143 0 01-.084.164c-1.249.56-1.952 1.875-1.952 3.047v12.525a.676.676 0 01-.238.53L7.397 21.8a.826.826 0 01-1.083-.005L.232 16.382A.677.677 0 010 15.858V2.939C0 1.321 1.396 0 3.106 0z",
  fill: "#ACB5C2"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M3 9l3.536-3.536L10.07 9l-3.535 3.536z"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M3 13l3.536-3.536L10.07 13l-3.535 3.536z"
});
function SvgCohortBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 22",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}
export default __webpack_public_path__ + "fonts/cohort-badge-52dee9979778480e2915145ab03965d3.svg";
export { SvgCohortBadge as ReactComponent };